module.exports = __webpack_public_path__ + "img/handraw_plus orange copie.facc13ad.svg";